import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { ErrorPageTemplate } from '@components/templates/ErrorPageTemplate/ErrorPageTemplate';

import { CompanyInformationDocument } from '@graphql/generated/graphql';

import { getPath } from '@services/RouteService/paths';

import { useQuery, useReactiveVar } from '@apollo/client';
import { authVar, currentLanguageVar } from '@boot/reactiveVariables';

export const ErrorPage = () => {
    const isLoggedIn = useReactiveVar(authVar).isLoggedIn;
    const navigate = useNavigate();
    const { data } = useQuery(CompanyInformationDocument, {
        context: { notifyOnError: true },
        skip: !isLoggedIn,
        variables: { targetLanguage: currentLanguageVar() },
    });
    const isNicole = data?.tenant.assetSettings.nicoleSetting === 'DEFAULT';

    const { t } = useTranslation();

    return (
        <ErrorPageTemplate
            buttonText={t('GO_BACK')}
            descriptionText={t('PAGE_NOT_FOUND_INFO')}
            isNicole={isNicole}
            isNotFound
            onClick={() => navigate(getPath({ path: '/incidents' }))}
            titleText={t('PAGE_NOT_FOUND')}
        />
    );
};
